import React, { useEffect, useState } from "react";
import $ from "jquery";
import {
  fileUploadAfterSignURL,
  generateMultipleSignUrl,
  updateStudentImage,
} from "../../actions/emActions";
import { Spinner } from "reactstrap";
import ImageCropComponent from "./ImageCropComponent";

const UpdateStudentImage = ({ studentImage, studentId, handleModalShow }) => {
  const [image, setImage] = useState(null);
  const [uploadedImage, setuploadedImage] = useState(null);
  const [uploadLoading, setuploadLoading] = useState(false);

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(selectedImage);
      setuploadedImage(selectedImage);
    }
  };

  console.log("Images", image);
  console.log("Images", uploadedImage);
  const uploadFeedFunc = () => {
    setuploadLoading(true);
    const items = [
      {
        filename: uploadedImage?.name,
        fileUserType: "student",
        contentType: uploadedImage?.type,
        label: "profileImages",
        userId: studentId.toString(),
      },
    ];

    let feedData = {};

    generateMultipleSignUrl(items)
      .then((res) => {
        debugger;
        if (res?.status === 201) {
          const uploadPromises = res?.data?.map((item, index) => {
            return fileUploadAfterSignURL(item?.signurl, uploadedImage);
          });

          feedData = {
            image: res?.data?.[0]?.filename,
            userId: studentId,
          };

          // Wait for all uploads to complete
          return Promise.all(uploadPromises);
        }
      })
      .then((uploadResults) => {
        // Check if all uploads were successful
        const allUploadsSuccessful = uploadResults.every(
          (result) => result.status === 200
        );
        if (allUploadsSuccessful) {
          updateStudentImage(feedData).then((res) => {
            if (res?.status === 201) {
              window.location.reload();
              setuploadLoading(false);
            } else {
              window.alert(res);
              console.log("Error", res);
            }
          });
        } else {
          // Handle the case where not all files were uploaded successfully
          console.log("Some files failed to upload.");
        }
      })
      .catch((error) => {
        // Handle any errors that occurred during the process
        console.error("Error during file upload:", error);
      })
      .finally(() => {
        setuploadLoading(false);
      });
  };

  useEffect(() => {
    setImage(studentImage);
  }, []);

  const removeImage = () => {
    setImage(null);
  };

  return (
    <div className="">
      <div
      className="profilePicuploadIcon"
        style={{ cursor: "pointer", fontSize: 16 }}
        onClick={handleModalShow}
      >
        <span>
          <i className="fa fa-plus" />
          {/* <u>Update Picture</u> */}
        </span>
      </div>

      <div className="modalForZoomLink">
        <div
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          id="myModalWait"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="d-flex justify-content-between">
                <h5 className="mb-4 p-2"></h5>
                <div className="d-flex">
                  <i
                    className="fa fa-times mr-3 mt-2"
                    data-toggle="modal"
                    data-target="#myModalWait"
                  ></i>
                </div>
              </div>
              <div className="modal-body text-center">
                {/* <div className="mb-4">
                  <label
                    className="font-weight-bold mb-0"
                    style={{ fontSize: 20 }}
                  >
                    Update Your Profile Picture
                  </label>
                  <br />
                  <span style={{ fontSize: 12 }}>
                    (Click on the avatar to upload a new picture)
                  </span>
                </div>

                <label htmlFor="fileInput">
                  <input
                    type="file"
                    accept="image/*"
                    id="fileInput"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <div
                    className="rounded-circle text-center bg-light"
                    style={{
                      cursor: "pointer",
                      border: "2px solid #ddd",
                      width: 200,
                      height: 200,
                      paddingTop: 7,
                    }}
                  >
                    {image ? (
                      <img
                        src={image}
                        alt="Selected"
                        style={{
                          width: 180,
                          height: 180,
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <i className=" text-secondary"></i>
                    )}
                  </div>
                </label>
                {image && (
                  <div className="mt-3">
                    <button
                      className="btn btn-success btn-sm"
                      onClick={uploadFeedFunc}
                      disabled={uploadLoading}
                    >
                      {uploadLoading ? <Spinner size="sm" /> : "Update Image"}
                    </button>
                  </div>
                )} */}

                <ImageCropComponent
                  studentImage={studentImage}
                  studentId={studentId}
                  handleModalShow={handleModalShow}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateStudentImage;
